export default {
    locale: (typeof window.globals !== "undefined" && typeof window.globals.language !== "undefined") ? window.globals.language : "en", // set locale
    fallbackLocale: "en",
    silentTranslationWarn: true,
    messages: {
        bg: {},
        ca: {},
        cs: {},
        da: {},
        de: {},
        el: {},
        en: {},
        es: {},
        fi: {},
        fr: {},
        gb: {},
        hi: {},
        // hr: {},
        hu: {},
        id: {},
        it: {},
        nl: {},
        no: {},
        pl: {},
        pt: {},
        ro: {},
        ru: {},
        sk: {},
        // sl: {},
        // tr: {},
        zh: {},
    },
};
